module.exports = "<template>\r\n  <span class=\"fake-link\" click.trigger=\"ExportExcel()\">Export Excel</span>\r\n</template>";